import { useSelector } from "react-redux";
import { ApplicationState } from "../rootStore";
import { SubcategoryState } from "./subcategoryTypes";
import { INITIAL_REDUCER_DATA, IReducerWithIsolated } from "@/main/services/reducerUtils";

export const useSubcategoryReducer = (keyReducer: string = "default") => {
	const returnSelector = useSelector((state: ApplicationState) => state.subcategory);
	if (keyReducer === "default") return returnSelector as IReducerWithIsolated<SubcategoryState>;

	const updateState = {
		...returnSelector,
		isolated: returnSelector.isolated[keyReducer] ?? INITIAL_REDUCER_DATA,
	};

	return updateState as IReducerWithIsolated<SubcategoryState>;
};
